module.exports = __webpack_public_path__ + "green-tick.png?9f3efca0595d093aa7d3bf0eac97026b";